import { ReducerUtil } from 'doctivity-shared/utils';

import {
  API_CLIENTS_TABLE,
  API_CLIENTS_LIST,
  API_CLIENTS_UPSERT,
} from 'store/actions/clientsActions';

export const clients = (state = {}, action = null) => {
  const result = ReducerUtil.simpleReduce(
    state,
    action,
    API_CLIENTS_TABLE,
    API_CLIENTS_LIST,
    API_CLIENTS_UPSERT,
  );
  if (result.actionConsumed) {
    return result.state;
  }
  return state;
};
